import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { ExtranetInvoiceOutput } from '../../../types/extranet-api.types';

/**
 * `/v1/extranet/invoices/:id` n'est pas livré par le back (404 PROD).
 * Or `ExtranetInvoiceOutput` contient déjà `rides[]` inline dans la liste —
 * on alimente donc le drawer depuis le cache de la query list. Le drawer
 * convertit lui-même les montants centimes → euros à l'affichage.
 */
export const useExtranetInvoiceDetail = (id: string | null) => {
  const queryClient = useQueryClient();

  const data = useMemo<ExtranetInvoiceOutput | undefined>(() => {
    if (!id) return undefined;
    const lists = queryClient.getQueriesData<ListOutput<ExtranetInvoiceOutput>>({
      queryKey: ['extranet', 'invoices', 'list'],
    });
    for (const [, listData] of lists) {
      const found = listData?.items?.find(i => i.id === id);
      if (found) return found;
    }
    return undefined;
  }, [id, queryClient]);

  return { data, isLoading: false, isError: false, error: null };
};
